document.addEventListener("DOMContentLoaded", () => {

    let noPopup = document.getElementById('NoPopupBeacon');

    const mailchimpModal = new bootstrap.Modal('#mailchimpModal');
    const registerModal = new bootstrap.Modal('#registerModal');

    const searchParams = new URLSearchParams(window.location.search);

    let bypassLogin = false;

    if (searchParams.has('bypasslogin')) {
        if (
            searchParams.get('bypasslogin') === 1
            || searchParams.get('bypasslogin') === '1'
            || searchParams.get('bypasspassword') === '1'
            || searchParams.get('bypasspassword') === 1
        ) {
            bypassLogin = true;
            setHaveSeenRegisterPopup();
        }
    }

    console.log('haveSeenRegisterPopup()');
    console.log(haveSeenRegisterPopup());

    if (noPopup === null && bypassLogin === false) {
        if (mailchimpModal !== undefined) {
            if (haveSeenRegisterPopup() === false) {
                setTimeout(() => {
                    setHaveSeenRegisterPopup();
                    if (registerModal._element.classList.contains('show') !== true) {
                        registerModal.hide();
                        mailchimpModal.show();
                        console.log('Show mailchimp popup');
                    } else {
                        console.log('Register popup open, not showing mailchimp popup');
                    }
                }, "3000");
            } else {
                console.log('Already seen mailchimp popup');
            }
        }
    } else {
        console.log('mailchimp popup not showing');
    }

    window.closeMailchimpPopup = function () {
        console.log('closeMailchimpPopup');
        if (mailchimpModal !== undefined) {
            setHaveSeenRegisterPopup();
            mailchimpModal.hide();
        }
    };

    window.showRegisterPopup = function () {
        console.log('showRegisterPopup');
        if (registerModal !== undefined) {
            setHaveSeenRegisterPopup();
            registerModal.show();
        }
    };
});

let haveSeenRegisterPopup = function () {
    return (Cookies.get('shownregisterpopup') === '1' || Cookies.get('shownregisterpopup') === '1');
}

let setHaveSeenRegisterPopup = function () {
    console.log('setHaveSeenRegisterPopup fired');
    Cookies.set('shownregisterpopup', '1', { expires: 1 });
}